import { render, staticRenderFns } from "./QACategory.vue?vue&type=template&id=6a30d631&"
import script from "./QACategory.vue?vue&type=script&lang=js&"
export * from "./QACategory.vue?vue&type=script&lang=js&"
import style0 from "./QACategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports